const ACCEPTED_DOCUMENT_TYPES =
  'image/*,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/plain';

export { ACCEPTED_DOCUMENT_TYPES };
